<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter1501phantomdreamtoochaotic">CHAPTER 1501 - PHANTOM DREAM TOO CHAOTIC</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter1502danger">CHAPTER 1502 - DANGER</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter1503maplewingheavenlyvalley">CHAPTER 1503 - MAPLE WING HEAVENLY VALLEY</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter1504weepingabyss">CHAPTER 1504 - WEEPING ABYSS</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter1505royalphoenixcang">CHAPTER 1505 - ROYAL PHOENIX CANG</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter1506greatwarwarmth">CHAPTER 1506 - GREAT WAR WARMTH</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter1507heavenandearthsealgiantdemonseal">CHAPTER 1507 - HEAVEN AND EARTH SEAL GIANT DEMON SEAL</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter1508vulnerabletoasingleblow">CHAPTER 1508 - VULNERABLE TO A SINGLE BLOW</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter1509holinessandenchantment" title="Link target outside of Sample">CHAPTER 1509 - HOLINESS AND ENCHANTMENT</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter1510thewhiteemperorseyes" title="Link target outside of Sample">CHAPTER 1510 - THE WHITE EMPEROR'S EYES</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter1511guilt" title="Link target outside of Sample">CHAPTER 1511 - GUILT</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter1512remnantbutterfly" title="Link target outside of Sample">CHAPTER 1512 - REMNANT BUTTERFLY</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter1513whatneedstobetakenback" title="Link target outside of Sample">CHAPTER 1513 - WHAT NEEDS TO BE TAKEN BACK</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter1514thefearthatcamefromthoseeyes" title="Link target outside of Sample">CHAPTER 1514 - THE FEAR THAT CAME FROM THOSE EYES</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter1515stilbene" title="Link target outside of Sample">CHAPTER 1515 - STILBENE</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter1516eyeofgod" title="Link target outside of Sample">CHAPTER 1516 - EYE OF GOD</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter1517creditor" title="Link target outside of Sample">CHAPTER 1517 - CREDITOR</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter1518returntoeasternregion" title="Link target outside of Sample">CHAPTER 1518 - RETURN TO EASTERN REGION</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter1519whatisawish" title="Link target outside of Sample">CHAPTER 1519 - WHAT IS A WISH</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter1520returntomountkunliu" title="Link target outside of Sample">CHAPTER 1520 - RETURN TO MOUNT KUNLIU</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter1521hesback" title="Link target outside of Sample">CHAPTER 1521 - HE'S BACK</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter1522theyefamilysdifficulties" title="Link target outside of Sample">CHAPTER 1522 - THE YE FAMILY'S DIFFICULTIES</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter1523tenyears" title="Link target outside of Sample">CHAPTER 1523 - TEN YEARS</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter1524arrivingatkuncity" title="Link target outside of Sample">CHAPTER 1524 - ARRIVING AT KUN CITY</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter1525beingtargeted" title="Link target outside of Sample">CHAPTER 1525 - BEING TARGETED</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter1526attractingdemonicbeasts" title="Link target outside of Sample">CHAPTER 1526 - ATTRACTING DEMONIC BEASTS</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter1527pawnshopeight" title="Link target outside of Sample">CHAPTER 1527 - PAWNSHOP EIGHT</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter1528mancity" title="Link target outside of Sample">CHAPTER 1528 - MAN CITY</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter1529homewhiteemperorcityofcloudrealm" title="Link target outside of Sample">CHAPTER 1529 - HOME WHITE EMPEROR CITY OF CLOUD REALM</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter1530dragonbloodsaints" title="Link target outside of Sample">CHAPTER 1530 - DRAGONBLOOD SAINTS</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter1531longqingyang" title="Link target outside of Sample">CHAPTER 1531 - LONG QINGYANG</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter1532imnotgoingtoletyougo" title="Link target outside of Sample">CHAPTER 1532 - I'M NOT GOING TO LET YOU GO</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter1533dragonbloodedsacredfamily" title="Link target outside of Sample">CHAPTER 1533 - DRAGON-BLOODED SACRED FAMILY</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter1534saintblooddragon" title="Link target outside of Sample">CHAPTER 1534 - SAINT BLOOD DRAGON</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter1535asinglespearstrikehadkilledthegreatsagekingofthedragonblood" title="Link target outside of Sample">CHAPTER 1535 - A SINGLE SPEAR STRIKE HAD KILLED THE GREAT SAGE KING OF THE DRAGON BLOOD</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter1536armorbreaking" title="Link target outside of Sample">CHAPTER 1536 - ARMOR-BREAKING</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter1537slayingformless" title="Link target outside of Sample">CHAPTER 1537 - SLAYING FORMLESS</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter1538demoniceyeholyraceunharmed" title="Link target outside of Sample">CHAPTER 1538 - DEMONIC EYE HOLY RACE UNHARMED</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter1539theheroicsoulshallnotperishbutshallremainintheworld" title="Link target outside of Sample">CHAPTER 1539 - THE HEROIC SOUL SHALL NOT PERISH BUT SHALL REMAIN IN THE WORLD</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter1540youvealreadyseenit" title="Link target outside of Sample">CHAPTER 1540 - YOU'VE ALREADY SEEN IT</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter1541heartbeast" title="Link target outside of Sample">CHAPTER 1541 - HEART BEAST</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter1542hesgoingtocomeout" title="Link target outside of Sample">CHAPTER 1542 - HE'S GOING TO COME OUT</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter1543destiny" title="Link target outside of Sample">CHAPTER 1543 - DESTINY</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter1544demoneyeholyracecome" title="Link target outside of Sample">CHAPTER 1544 - DEMON EYE HOLY RACE COME</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter1545allofyoucomeatmetogether" title="Link target outside of Sample">CHAPTER 1545 - ALL OF YOU COME AT ME TOGETHER</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter1546flawless" title="Link target outside of Sample">CHAPTER 1546 - FLAWLESS</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter1547destructionextremelyretrogradespear" title="Link target outside of Sample">CHAPTER 1547 - DESTRUCTION--EXTREMELY RETROGRADE SPEAR</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter1548availableatanytime" title="Link target outside of Sample">CHAPTER 1548 - AVAILABLE AT ANY TIME</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter1549ragerealmvioletimperialcity" title="Link target outside of Sample">CHAPTER 1549 - RAGE REALM VIOLET IMPERIAL CITY</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter1550hui" title="Link target outside of Sample">CHAPTER 1550 - HUI</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter1551involvingtheworld" title="Link target outside of Sample">CHAPTER 1551 - INVOLVING THE WORLD</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter1552naturaldestiny" title="Link target outside of Sample">CHAPTER 1552 - NATURAL DESTINY</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter1553daughterofthewhiteemperor" title="Link target outside of Sample">CHAPTER 1553 - DAUGHTER OF THE WHITE EMPEROR</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter1554shivering" title="Link target outside of Sample">CHAPTER 1554 - SHIVERING</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter1555contract" title="Link target outside of Sample">CHAPTER 1555 - CONTRACT</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter1556imissyousomuch" title="Link target outside of Sample">CHAPTER 1556 - I MISS YOU SO MUCH</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter1557whenflowersbloomagainpeoplewillmeetagain" title="Link target outside of Sample">CHAPTER 1557 - WHEN FLOWERS BLOOM AGAIN PEOPLE WILL MEET AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter1558thereisadivinewillintheworld" title="Link target outside of Sample">CHAPTER 1558 - THERE IS A DIVINE WILL IN THE WORLD</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter1559apersonwhoisunabletoseethrough" title="Link target outside of Sample">CHAPTER 1559 - A PERSON WHO IS UNABLE TO SEE THROUGH</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter1560compress" title="Link target outside of Sample">CHAPTER 1560 - COMPRESS</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter1561placeofinscriptions" title="Link target outside of Sample">CHAPTER 1561 - PLACE OF INSCRIPTIONS</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter1562tianjicity" title="Link target outside of Sample">CHAPTER 1562 - TIAN JI CITY</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter1563wanxiangformation" title="Link target outside of Sample">CHAPTER 1563 - WANXIANG FORMATION</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter1564consequences" title="Link target outside of Sample">CHAPTER 1564 - CONSEQUENCES</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter1565breakthroughtheformation" title="Link target outside of Sample">CHAPTER 1565 - BREAK THROUGH THE FORMATION</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter1566notsomething" title="Link target outside of Sample">CHAPTER 1566 - NOT SOMETHING</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter1567havebeencheated" title="Link target outside of Sample">CHAPTER 1567 - HAVE BEEN CHEATED</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter1568evilkillingswordformation" title="Link target outside of Sample">CHAPTER 1568 - EVIL KILLING SWORD FORMATION</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter1569onewavethreetwistsandturns" title="Link target outside of Sample">CHAPTER 1569 - ONE WAVE THREE TWISTS AND TURNS</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter1570masterofthetempleofheavenlysecrets" title="Link target outside of Sample">CHAPTER 1570 - MASTER OF THE TEMPLE OF HEAVENLY SECRETS</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter157110000yearimmortaltalismanspirittree" title="Link target outside of Sample">CHAPTER 1571 - 10000 YEAR IMMORTAL-TALISMAN SPIRIT TREE</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter1572mistysky" title="Link target outside of Sample">CHAPTER 1572 - MISTY SKY</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter1573redmoondescends" title="Link target outside of Sample">CHAPTER 1573 - RED MOON DESCENDS</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter1574astrangeworld" title="Link target outside of Sample">CHAPTER 1574 - A STRANGE WORLD</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter1575plastid" title="Link target outside of Sample">CHAPTER 1575 - PLASTID</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter1576eviltree" title="Link target outside of Sample">CHAPTER 1576 - EVIL TREE</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter1577mistyskycollapse" title="Link target outside of Sample">CHAPTER 1577 - MISTY SKY COLLAPSE</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter1578thegreatdao3000chaospalm" title="Link target outside of Sample">CHAPTER 1578 - THE GREAT DAO 3000 CHAOS PALM</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter1579frostonsnow" title="Link target outside of Sample">CHAPTER 1579 - FROST ON SNOW</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter1580granddaoscripture" title="Link target outside of Sample">CHAPTER 1580 - GRAND DAO SCRIPTURE</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter1581escapeday" title="Link target outside of Sample">CHAPTER 1581 - ESCAPE DAY</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter1582return" title="Link target outside of Sample">CHAPTER 1582 - RETURN</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter1583heavengullymountainsdemonregion" title="Link target outside of Sample">CHAPTER 1583 - HEAVEN GULLY MOUNTAINS DEMON REGION</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter1584demonregionpattern" title="Link target outside of Sample">CHAPTER 1584 - DEMON REGION PATTERN</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter1585demonemperor" title="Link target outside of Sample">CHAPTER 1585 - DEMON EMPEROR</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter1586youareverymuchlikeaperson" title="Link target outside of Sample">CHAPTER 1586 - YOU ARE VERY MUCH LIKE A PERSON</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter1587greatemperor" title="Link target outside of Sample">CHAPTER 1587 - GREAT EMPEROR</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter1588whatisthesaintscongress" title="Link target outside of Sample">CHAPTER 1588 - WHAT IS THE SAINTS' CONGRESS</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter1589lastshredofdignity" title="Link target outside of Sample">CHAPTER 1589 - LAST SHRED OF DIGNITY</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter1590holyfamilygathering" title="Link target outside of Sample">CHAPTER 1590 - HOLY FAMILY GATHERING</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter1591thegreatpengriseswiththesamewindforaday" title="Link target outside of Sample">CHAPTER 1591 - THE GREAT PENG RISES WITH THE SAME WIND FOR A DAY</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter1592qishanlingdazzlingpeak" title="Link target outside of Sample">CHAPTER 1592 - QI SHAN LING DAZZLING PEAK</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter1593apparentsimilarity" title="Link target outside of Sample">CHAPTER 1593 - APPARENT SIMILARITY</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter1594loverival" title="Link target outside of Sample">CHAPTER 1594 - LOVE RIVAL</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter1595aloofhumble" title="Link target outside of Sample">CHAPTER 1595 - ALOOF HUMBLE</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter1596saintrebirth" title="Link target outside of Sample">CHAPTER 1596 - SAINT REBIRTH</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter1597thesacredfamilysassemblyhadofficiallybegun" title="Link target outside of Sample">CHAPTER 1597 - THE SACRED FAMILY'S ASSEMBLY HAD OFFICIALLY BEGUN</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter1598thecrueltyofcompetition" title="Link target outside of Sample">CHAPTER 1598 - THE CRUELTY OF COMPETITION</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter1599howfarcanthoseeyessee" title="Link target outside of Sample">CHAPTER 1599 - HOW FAR CAN THOSE EYES SEE</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter1600unstoppableforce" title="Link target outside of Sample">CHAPTER 1600 - UNSTOPPABLE FORCE</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?76fab0d8